import type {LocaleV3} from '@smart/locale-service';
import {INTERRUPTION_START_PATHS} from '../constants';
import {getLanguageMappedPaths} from './get-language-mapped-paths';

export const isValidInterruptionStartPath = (path: string, locale: LocaleV3) =>
  getLanguageMappedPaths(INTERRUPTION_START_PATHS, locale).includes(path);
